export default __webpack_public_path__ + "static/media/new-dark-accent.04cdbd5a.svg";